import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardFooter from "components/Card/CardFooter.js";


import styles from "assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.js";
import { useSelector } from "react-redux";
import * as authAPI from '../../api/auth';
import Overlay from "../../components/Overlay/Overlay";

const useStyles = makeStyles(styles);

export default function LockScreenPage() {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const appUser = useSelector((state) => state.app.user);
  const [pin, setPin] = React.useState("")
  const [success, setSuccess] = React.useState(false)
  const [error, setError] = React.useState("")
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });
  const classes = useStyles();
  const submit = (e) => {
    e.preventDefault();
    setLoading(true)
    // authAPI
    //   .reauthenticate(appUser.user_name, pin)
    //   .then(() => {
    //     setLoading(false)
    //     setSuccess(true)
    //     setPin('');
    //   })
    //   .catch((err) => {
    //     setLoading(false)
    //     setError('Incorrect PIN');
    //     setPin('');
    //     window.setTimeout(() => setError(""), 1500)
    //   });
  };

  return (
    <div className={classes.container}>
      <form onSubmit={submit}>
        <Card
          profile
          className={classes.customCardClass + " " + classes[cardAnimaton]}
        >
          <CardAvatar profile className={classes.cardAvatar}>
              <div className={classes.photo} style={{backgroundImage:'url('+appUser.avatar_url+')'}} alt="..." />
          </CardAvatar>
          <CardBody profile>
            <h4 className={classes.cardTitle}>{appUser.first_name} {appUser.last_name}</h4>
            <CustomInput
              labelText="Enter PIN"
              id="company-disabled"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                type: "text",
                autoComplete: "off",
                minLength: 4,
                className: classes.password,
                value: pin,
                onChange: (e) => setPin(e.currentTarget.value),
              }}
            />
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            <Button type='submit' color="primary">
              Unlock
            </Button>
            <Button simple color="rose">
              Logout
            </Button>
          </CardFooter>
          {success && <Overlay style={{fontSize:96}} type='success' />}
          {error && <Overlay style={{fontSize:96}} type='error' message={error}/>}
          {loading && <Overlay size={62} type='loading'/>}
        </Card>
      </form>
    </div>
  );
}
